import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordbreak',
})
export class WordbreakPipe implements PipeTransform {
  transform(value: string, characters: Array<string>): string {
    characters.forEach(char => {
      value = value.replace(new RegExp(char, 'g'), char + '<wbr>');
    });
    return value;
  }
}
